import React, { Component } from 'react'
import { connect } from 'react-redux'
import { 
	loginUser, 
	changeTitle, 
	clearActivation,
	clearUnsubscribeData,
	openModal
} from 'state/actions'

import { getCurrentUser } from 'state/selectors/userSelectors'

import { withRouter } from 'react-router'
import Loader from 'components/loader/loader'
import { Link } from 'react-router-dom'
import SmoothCollapse from 'react-smooth-collapse'

import Icon from 'components/icon/icon'

import yup from 'yup'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

class Login extends Component {
	title = 'Welcome back.'
	invitationId = null
	state = {
		isLoading: false,
		email: '',
		password: '',
	}

	updateField = e => {
		this.setState({
			[e.target.name]: e.target.value,
		})
	}

	UNSAFE_componentWillMount = _ => {
		const {
			changeTitle,
			pendingInvitation,
			pendingNotification,
			emailValidation,
			handleError,
			forcedEmail,
			unsubscribeData,
			clearUnsubscribeData
		} = this.props

		changeTitle('Log in')

		if(window.initialQueryValues && window.initialQueryValues.includes('tryBusiness')){
			handleError('Please log in to access this content.')
		}else if(window.initiallyRequestedLocation){
			handleError('Please log in to access this content.')
		}else if(pendingInvitation){
			handleError('Please log in to accept this invitation.')
			this.invitationId = pendingInvitation.id
		}else if(pendingNotification){
			handleError('Please log in to view this notification.')
		}else if(emailValidation){
			handleError(emailValidation.text)
		}else if(unsubscribeData){
			handleError(`You've been unsubscribed from 'Weekly Update' emails.`)

			clearUnsubscribeData()
		}else if(window.campaign && window.campaign === 'threeForFree'){
			handleError(`Almost done! Just log in to extend your free trial.`)
		}else if(window.campaign){
			handleError(`Howdy! Log in to complete this action.`)
		}

		if(forcedEmail){
			this.setState({
				email: forcedEmail
			})
		}
	}

	handleFormSubmit = async e => {
		e.preventDefault()

		const { 
			email, 
			password 
		} = this.state

		const {
			loginUser,
			handleError,
			history,
			clearActivation
		} = this.props

	    //Login validation schema
	    var loginSchema = yup.object().shape({
	    	email: yup.string().email("That doesn't look like a valid email.").required('Please enter an email address.'),
	    	password: yup.string().required('Please enter a password.'),
	    })

	    // Run input fields against schema
	    try {
	    	await loginSchema.validate({ ...this.state })
	    } catch (error) {
	    	return this.props.handleError(error.message)
	    }

	    this.setState({
	    	isLoading: true,
	    })

	    loginUser({ email, password, invitationId: this.invitationId }, (error, res) => {
	    	if (error) {
	    		let errorMessage = error.message ? error.message : 'Ah jeez! A server error has occurred.';
	    		handleError(errorMessage)
	    		this.setState({
	    			isLoading: false,
	    		})
	    		return
			}

			const {
				userData,
				allAccounts,
			} = this.props

	    	if (userData && res.ok) {
				// you've probably been booted from an account.
				if(!allAccounts){
					return history.push('/auth/register',{
						state: {
							email,
							password
						}
					})
				}

				let lastSeenAccount = allAccounts[userData.last_open_account_id]

				if(!lastSeenAccount || !lastSeenAccount.slug){
					if(Object.keys(allAccounts).length){
						Object.keys(allAccounts).forEach(accountId => {
							let accountObject = allAccounts[accountId]

							if(accountObject && accountObject.slug && accountObject.pivot && accountObject.pivot.user_id === userData.id){
								lastSeenAccount = allAccounts[accountId];
							}
						})

					}
				}

				clearActivation()

				if(lastSeenAccount && lastSeenAccount.slug){
					return history.push(this.getNextUrl(lastSeenAccount))
				}else{
					return history.push('/auth/register')
				}
	    	}
	    })
	}

	getNextUrl = account => {
		const initiallyRequestedLocation = window.initiallyRequestedLocation

		if(initiallyRequestedLocation && initiallyRequestedLocation.pathname.startsWith('/'+account.slug+'/')){
			let newUrl = initiallyRequestedLocation.pathname

			if(initiallyRequestedLocation.search){
				newUrl += initiallyRequestedLocation.search
			}

			window.initiallyRequestedLocation = null

			return newUrl
		}

		return `/${account.slug}/dashboard`
	}

	render() {
		const {
			isLoading,
			email,
			password
		} = this.state

		const {
			validateResponse,
			handleDismiss,
		} = this.props

		let formClass = 'auth-fields'

		if (this.state.isLoading) {
			formClass += ' faded'
		}

		let responseExpanded = false

		if(validateResponse){
			responseExpanded = true
		}

		return (
			<div>
				<h1>
					{this.title}
				</h1>
				<Loader 
					visible={isLoading} 
					noText={true} 
				/>
				<form 
					onSubmit={this.handleFormSubmit} 
					noValidate 
					className={formClass}
				>
					<SmoothCollapse 
						expanded={responseExpanded}
					>
						<ValidateResponse 
							dismissCallback={handleDismiss} 
							response={validateResponse} 
							timeout={5000} 
						/>
					</SmoothCollapse>
					<div className="form-wrap">
						<input 
							value={email} 
							onChange={this.updateField} 
							placeholder="Email address" 
							name="email" 
							type="email" 
						/>
					</div>
					<div className="form-wrap">
						<input 
							value={password} 
							onChange={this.updateField} 
							placeholder="Password" 
							name="password" 
							type="password" 
						/>
						<Link 
							className="form-wrap-button tooltip-trigger" 
							to="/auth/recover"
						>
							<Icon 
							 	name="fe-help-circle" 
							/>
							<div className="tooltip">
								Forgot your password?
							</div>
						 </Link>
					</div>
					<button 
						className="button huge" 
						type="submit"
					>
						Login
					</button>
					<span 
						className="auth-swap"
					>
						New here? <Link to={'/auth/register'}>Register an account</Link>.
					</span>
				</form>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		message: state.auth.message,
		userData: getCurrentUser(state),
		allAccounts: state.account.entities ? state.account.entities.accounts : {},
		pendingInvitation: state.auth.pendingInvitation,
		pendingNotification: state.auth.pendingNotification,
		emailValidation: state.auth.emailValidation,
		unsubscribeData: state.auth.unsubscribeData
	}
}

export default withRouter(connect(mapStateToProps, { 
	loginUser, 
	changeTitle, 
	clearActivation,
	clearUnsubscribeData,
	openModal
})(withValidateResponse(Login)))
